export var Paths;

(function (Paths) {
  Paths["List"] = "/users/:userVanity/playlists";
  Paths["Show"] = "/users/:userVanity/playlists/:playlistSlug";
  Paths["ListVideos"] = "/users/:userVanity/playlists/:playlistSlug/videos";
  Paths["FindVideoIndex"] = "/users/:userVanity/playlists/:playlistSlug/video_index";
})(Paths || (Paths = {}));